import React from 'react'
import { MasteryStatusPacing, MasteryStatus, MasteryPacing, MasteryChange } from '@/enums'
import './StatusCard.scss'
import { MasteryChangeIndicator } from '../RolloverModal/MasteryChangeIndicator';

interface StatusCardProps {
  status: MasteryPacing;
  masteryStart: MasteryPacing;
  masteryEnd: MasteryPacing;
  observations: number;
  errors: number;
  showGraph?: boolean;
  preReqModal?: boolean;
}

const StatusCard: React.FC<StatusCardProps> = ({
  status = MasteryStatusPacing.NOT_DEVELOPED,
  masteryStart,
  masteryEnd,
  observations,
  errors,
  showGraph,
  preReqModal
}) => {
  const statusMapping = {
    [MasteryPacing.BELOW_GRADE_LEVEL]: MasteryStatus.NOT_DEVELOPED,
    [MasteryPacing.AT_GRADE_LEVEL]: MasteryStatus.DEVELOPING,
    [MasteryPacing.AHEAD_OF_GRADE_LEVEL]: MasteryStatus.LIKELY_MASTERED,
    [MasteryPacing.NO_DATA]: MasteryStatus.NO_DATA,
  };

  const getMasteryChangeGraphPath = () => {
    if (masteryStart === MasteryPacing.NO_DATA && masteryEnd === MasteryPacing.NO_DATA) {
      return '/src/features/wizard/components/RolloverModal/MasteryChangeGraphs/NoDataGraphs/noDataGraph.svg';
    }

    if (!masteryStart || !masteryEnd) {
      return null;
    }

    const pacingToStatusName = {
      [MasteryPacing.BELOW_GRADE_LEVEL]: 'notDeveloped',
      [MasteryPacing.AT_GRADE_LEVEL]: 'developing',
      [MasteryPacing.AHEAD_OF_GRADE_LEVEL]: 'likelyMastered',
      [MasteryPacing.NO_DATA]: 'noData',
    };

    const startStatus = pacingToStatusName[masteryStart];
    const endStatus = pacingToStatusName[masteryEnd];

    let folder = '';
    let color = '';

    switch (masteryEnd) {
      case MasteryPacing.AHEAD_OF_GRADE_LEVEL:
        folder = 'LikelyMasteredGraphs';
        color = 'green';
        break;
      case MasteryPacing.BELOW_GRADE_LEVEL:
        folder = 'NotDevelopedGraphs';
        color = 'red';
        break;
      case MasteryPacing.AT_GRADE_LEVEL:
        folder = 'DevelopingGraphs';
        color = 'yellow';
        break;
      default:
        return null;
    }

    let filename = `${color}-${startStatus}-${endStatus}.svg`;
    if (folder === 'NotDevelopedGraphs') {
      if (startStatus === 'likelyMastered') {
        filename = `${color}-likleyMastered-${endStatus}.svg`;
      }
      if (startStatus === 'developing') {
        filename = `${color}-devloping-${endStatus}.svg`;
      }
    }

    return `/src/features/wizard/components/RolloverModal/MasteryChangeGraphs/${folder}/${filename}`;
  };

  const graphPath = getMasteryChangeGraphPath();

  const displayText = (statusMapping[status as keyof typeof statusMapping] || status).replace('_', ' ').toLowerCase().replace(/^./, char => char.toUpperCase());

  return (
    <div className={`d-flex flex align-items-start status-card status-card-${status}${!showGraph || !graphPath ? ' status-card--no-graph' : ''}`}>
      {graphPath && !preReqModal && (
        <div className="mastery-change-graph">
          <img src={graphPath} alt="Mastery change graph" />
        </div>
      )}
      <div className="status-card-container d-flex flex-column align-items-start">
      <div className="status-card-content d-flex align-items-center w-100 justify-content-between">
        <div className="d-flex align-items-start gap-2">
          {!showGraph && (
            <div className="status-dot-container">
              <div className="status-dot" />
            </div>
          )}
          <div className="d-flex flex-column align-items-start">
            <span className="status-text">{displayText}</span>
            <span className="status-card-text">
              {observations} observations
            </span>
            <span className="status-card-text">
              {errors} errors
            </span>
          </div>
        </div>
      </div>
      <div className="status-card-change">
        {!preReqModal && <MasteryChangeIndicator startMastery={masteryStart} endMastery={masteryEnd} />}
      </div>
    </div>
    </div>
  )
}

export default StatusCard